import { API_BASE_URL } from '../config';

/**
 * Convert decimal hours to hours and minutes
 * 
 * @param {number} decimalHours
 * @returns {{hours: number, minutes: number}}
 */
export function convertDecimalHoursToHoursMinutes(decimalHours) {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return { hours, minutes };
}

/**
 * Check if a work has a built-in type
 * 
 * @param {object} work
 * @returns {boolean}
 */
export function workHasBuiltInType(work) {
    return work?.work_type?.is_builtin || false;
}

/**
 * Get the used localStorage in KB
 * 
 * @returns {number}    The used localStorage in KB
 */
export function getUsedLocalStorage() {
    let total = 0;
    for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
            total += localStorage.getItem(key).length;
        }
    }
    return total / 1024; // Convert to KB
}

/**
 * Fix the protocol of a URL.
 * If the API_BASE_URL is http, the URL will be converted to http, otherwise it will be converted to https.
 * 
 * @param {string} url
 * @returns {string}
 */
export function fixUrlProtocol(url) {
    try {
        const baseProtocol = new URL(API_BASE_URL).protocol;
        const parsed = new URL(url);
        parsed.protocol = baseProtocol;
        return parsed.toString();
    } catch {
        return url; // fallback en caso de URL inválida
    }
};